export default function SciPy_Interpolation() {
  return (
    <div>
      <h1>SciPy Interpolation</h1>
    </div>
  );
}
